export default "/fonts/Urbanist-ExtraBold.ttf?01f6fa390405c9d3db72dd2d256e33a7";